import { render, staticRenderFns } from "./ConfirmDlg.vue?vue&type=template&id=36f23521"
import script from "./ConfirmDlg.ts?vue&type=script&lang=ts&external"
export * from "./ConfirmDlg.ts?vue&type=script&lang=ts&external"
import style0 from "./ConfirmDlg.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports